import {
  Box,
  Container,
  SimpleGrid,
  GridItem,
  Button,
  FormControl,
  FormLabel,
  Input,
  chakra,
  useToast,
  FormHelperText,
  Text,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLoginMutation } from "../generated/graphql";
import { useStaffStore } from "../store/staff";

type Inputs = {
  email: string;
  password: string;
};

const schema: yup.SchemaOf<Inputs> = yup.object({
  email: yup.string().email().required(),
  password: yup.string().min(3).required(),
});

function Login() {
  const loginUser = useStaffStore((store) => store.loginStaff);
  const [loginMutation, { loading }] = useLoginMutation();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: Inputs) => {
    try {
      const res = await loginMutation({
        variables: { data },
      });
      loginUser(res.data!.login);
      window.location.href = "/";
    } catch (error: any) {
      return toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <SimpleGrid columns={{ base: 1, md: 4 }} gap={0} height="100vh">
      <GridItem bgColor="white" colSpan={3}>
        <Container h={"full"}>
          <Box
            h={"full"}
            display="flex"
            justifyContent={"center"}
            flexDir="column"
            alignItems="center"
            pt={5}
          >
            <Text fontWeight={"bold"} fontSize="xl">
              İlgi Otizm Yönetim Paneli
            </Text>
            <chakra.form
              w="full"
              experimental_spaceY={8}
              onSubmit={handleSubmit(onSubmit)}
            >
              <FormControl>
                <FormLabel>E-mail</FormLabel>
                <Input size="lg" {...register("email", { required: true })} />
                <FormHelperText color="red.500">{errors.email?.message}</FormHelperText>
              </FormControl>
              <FormControl>
                <FormLabel>Password</FormLabel>
                <Input type="password" size="lg" {...register("password")} />
                <FormHelperText color="red.500">
                  {errors.password?.message}
                </FormHelperText>
              </FormControl>

              <Box display="flex" justifyContent="center">
                <Button colorScheme="blue" size="lg" type="submit" disabled={loading}>
                  Submit
                </Button>
              </Box>
            </chakra.form>
          </Box>
        </Container>
      </GridItem>
      <GridItem colSpan={1} bgGradient="linear(to-b, blue.300, blue.600)"></GridItem>
    </SimpleGrid>
  );
}

export default Login;
